export const partnerAuditTranslation = {
  title: 'partneraudit-title',
  buttons: {
    apply: 'partneraudit-buttons-apply',
  },
  table: {
    columns: {
      created: 'partneraudit-table-columns-created',
      action: 'partneraudit-table-columns-action',
      sourse: 'partneraudit-table-columns-sourse',
      partnerId: 'partneraudit-table-columns-partner_id',
      workflowStatus: 'partneraudit-table-columns-workflow_status',
      modifiedValues: 'partneraudit-table-columns-modified_values',
      companyLegalName: 'partneraudit-table-columns-company_legal_name',
      addr1: 'partneraudit-table-columns-addr1',
      addr2: 'partneraudit-table-columns-addr2',
      addr3: 'partneraudit-table-columns-addr3',
      city: 'partneraudit-table-columns-city',
      country: 'partneraudit-table-columns-country',
      state: 'partneraudit-table-columns-state',
      zipCode: 'partneraudit-table-columns-zip_code',
      profilingComment: 'partneraudit-table-columns-profiling_comment',
      approverComment: 'partneraudit-table-columns-approver_comment',
    },
  },
}
